import { render, staticRenderFns } from "./stock-warning-modal.vue?vue&type=template&id=53f31f1c&"
import script from "./stock-warning-modal.vue?vue&type=script&lang=js&"
export * from "./stock-warning-modal.vue?vue&type=script&lang=js&"
import style0 from "./stock-warning-modal.vue?vue&type=style&index=0&id=53f31f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports